import SnapshotChart from "./snapshotChart";
import ReportTable from "./reportTable";
import { Report, ReportColumn } from "/app/src/models";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import VarianceChips from "./VarianceChips";
import { Spinner } from "@heroui/react";

/**
 * Component to display the snapshot chart and report table
 * @param param0 props contain report and report columns
 */
export default function Data({
  report,
  columns,
}: {
  report: Report;
  columns: ReportColumn[];
}) {
  const [dateValues, setDateValues] = useState({
    cache_expiration: null,
    powerpick_timestamp: null,
    variance_timestamp: null,
  });
  useTranslation();

  const handleDateValues = useCallback((values) => {
    setDateValues(values);
  }, []);
  return (
    <div className="reportData">
      {report.id ? (
        <>
          <SnapshotChart report={report} />
          <VarianceChips report={report} dateValues={dateValues} />
          <ReportTable
            columns={columns}
            report={report}
            dateValues={handleDateValues}
          />
        </>
      ) : (
        <div className="dataTable flex justify-center p-10 h-[400px]">
          <Spinner size="lg" />
        </div>
      )}
    </div>
  );
}
